// Nomi in una frase: «A», «A e B», «A, B e C». La congiunzione arriva dalle traduzioni.
export const joinNames = (names: string[], conjunction: string): string => {
  if (names.length <= 1) return names[0] ?? '';
  return `${names.slice(0, -1).join(', ')} ${conjunction} ${
    names[names.length - 1]
  }`;
};

// Riga indirizzo come nella scheda dello step "dove" («Via Roma, 1 - Treviso»), saltando
// le parti mancanti
export const formatCenterAddress = (
  address?: string | null,
  city?: string | null
): string =>
  [address, city]
    .filter(
      (value): value is string =>
        value !== undefined && value !== null && value.trim() !== ''
    )
    .join(' - ');
